import NextLink from 'next/link'

import EastIcon from '@mui/icons-material/East'
import { Link } from '@mui/material'

import { getCategoryHierarchy } from '@/helpers/getCategoryHierarchy'
import { getTarget } from '@/helpers/getTarget'
import { useHeaderContext } from '@/hooks/useHeaderContext'
import { useTranslations } from '@/hooks/useTranslations'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type * as React from 'react'
import type { UnpackedSanityRichLink } from '@/lib/queries/sanityQueryStrings'

interface SanityLinkProps {
  sanityLink: UnpackedSanityRichLink
  overwriteLinkName?: string
}
export const SanityRichLink: React.FC<SanityLinkProps> = ({ sanityLink, overwriteLinkName }) => {
  const { language } = useTranslations()
  const { catalog } = useHeaderContext()
  let url = undefined,
    name = undefined,
    target = '_self'

  switch (sanityLink?._type) {
    case 'link':
      url = sanityLink?.url
      name = overwriteLinkName ?? sanityLink?.externalName?.[language]
      target = getTarget(sanityLink?.openInNewTab)?.target ?? '_self'
      break
    case 'article':
      url = sanityLink?.slug?.current ? '/article/' + sanityLink?.slug?.current : undefined
      name = overwriteLinkName ?? sanityLink?.title
      break
    case 'page':
      url = sanityLink?.slug?.current ? '/page/' + sanityLink?.slug?.current : undefined
      name = overwriteLinkName ?? sanityLink?.title
      break
    case 'category':
      url = sanityLink?.sapId ? getCategoryHierarchy(catalog, sanityLink?.sapId)?.url : undefined
      name = overwriteLinkName ?? sanityLink?.title?.[language]
      break
  }

  return (
    url &&
    name && (
      <Link
        component={NextLink}
        prefetch={false}
        href={url}
        target={target}
        color="inherit"
        sx={{
          textDecoration: 'none',
          fontWeight: 700,
          display: 'flex',
          gap: 1,
          alignItems: 'center',

          [theme.breakpoints.down('md')]: {
            fontSize: '14px',
          },
        }}
      >
        {name}
        <EastIcon fontSize="small" />
      </Link>
    )
  )
}
